export default __webpack_public_path__ + "static/media/ethereum.b5a41dac.svg";